const CertificateStatuses = {
  UNCONFIRMED: 0, 
  CONFIRMED: 1,
  VOID: 3
};

export default CertificateStatuses;